import PropTypes from 'prop-types';
import React from 'react';
import IconButton from 'material-ui/IconButton';
import InlineButton from 'shared/components/InlineButton';
import Help from 'material-ui/svg-icons/action/help';
import * as Colors from 'material-ui/styles/colors';

const sassStyles = require('./styles.scss');

const supportLink = (toolTip, link) => {
  let tip;
  if ( toolTip.indexOf('live eBay listings') !== -1 ) {
    const split = toolTip.split('live eBay listings');
    tip = (
      <span>
        <span dangerouslySetInnerHTML={{__html: split[0]}}/>
        <InlineButton href={link} target="_blank" style={{color: Colors.lightGreen500}}>
          live eBay listings
        </InlineButton>
        <span dangerouslySetInnerHTML={{__html: split[1]}}/>
      </span>
    );
  } else {
    tip = <span dangerouslySetInnerHTML={{__html: toolTip}}/>;
  }
  return tip;
};

const LineWithHelp = ({ className, style, title, position, iconColor, toolTipStyle, supportLiveEbayListings}) => {
  let line = null;
  title.replace(/\[h]([\s\S]+)\[\/h]/i, (search, toolTip, start, all) => {
    line = (
      <li className={className ? className : ''} style={style}>
        <span
          dangerouslySetInnerHTML={{__html: all.replace(search, '')}}
          style={{verticalAlign: 'middle'}}
        />
        <IconButton
          tooltip={
            <div style={{fontSize: 14, margin: '8px 0', ...toolTipStyle}}>
              {supportLink(toolTip, supportLiveEbayListings)}
            </div>
          }
          containerElement={
            <div></div>
          }
          iconStyle={{height: 18, width: 18}}
          style={{height: 36, width: 0, padding: '9px 0px', display: 'inline-block', verticalAlign: 'middle', position: 'relative', left: 9}}
          tooltipPosition={position}
          tooltipStyles={{cursor: 'default', transform: 'translateY(-5px)'}}
        >
          <Help color={iconColor} className={sassStyles.icon} />
        </IconButton>
      </li>
    );
  });
  return line ? line : <li dangerouslySetInnerHTML={{__html: title}} />;
};

LineWithHelp.propTypes = {
  title: PropTypes.string,
  iconColor: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  supportLiveEbayListings: PropTypes.string
};

LineWithHelp.defaultProps = {
  position: 'bottom-left',
};

export default LineWithHelp;